import React from 'react'
import { useFeatureFlag } from 'utils/context/FeatureFlagsContext'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { Notes } from '../Notes'
import { Accounting } from './Accounting'
import { DeprecatedCompanyInformation } from './Cards/CompanyOverview'
import { Insurance as HighwayInsurance } from './Cards/Insurance'
import { CarrierStatus } from './CarrierStatus'
import { Commodities } from './Commodities'
import { Contact } from './Contact'
import DocumentChecklist from './Documents'
import { FMCSA } from './FMCSA'
import HighwayCarrier from './HighwayCarrier/HighwayCarrier'
import { Insurance } from './Insurance'
import { References } from './References'
import { Vins } from './Vins'

export const DeprecatedComplianceTab = () => {
  const { userPermissions } = useUserDetails()
  const { canManageCarrierVin } = userPermissions || {}

  const isHighwayMilestoneThreeInsuranceCardEnabled = useFeatureFlag(
    'highwayMilestoneThreeInsuranceCard'
  )

  return (
    <>
      <div className='row'>
        <div className='col-md-4'>
          <div className='pv4'>
            <CarrierStatus />
          </div>
          <div className='pv4'>
            <HighwayCarrier />
          </div>
          <div className='pv4'>
            <FMCSA />
          </div>
          <div className='pv4'>
            <DocumentChecklist />
          </div>
          <div className='pv4'>
            <Notes />
          </div>
        </div>
        <div className='col-md-8'>
          <div className='pv4'>
            <DeprecatedCompanyInformation />
          </div>
          <div className='pv4'>
            <Contact />
          </div>
          {canManageCarrierVin && (
            <div className='pv4'>
              <Vins />
            </div>
          )}
          {isHighwayMilestoneThreeInsuranceCardEnabled && (
            <div className='pv4'>
              <HighwayInsurance />
            </div>
          )}
          <div className='pv4'>
            <Insurance />
          </div>
          <div className='pv4'>
            <Commodities />
          </div>
          <div className='pv4'>
            <Accounting />
          </div>
          <div className='pv4'>
            <References />
          </div>
        </div>
      </div>
    </>
  )
}
